import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CommonModule } from '@angular/common';
import { getSotrRfpComplienceTemplate } from '../../pre-ready-tepmlate';

@Component({
  standalone: true,
  imports: [EditorModule, CommonModule, FormsModule, ReactiveFormsModule],
  selector: 'app-sotr-rfp-complience-matrix',
  templateUrl: './sotr-rfp-complience-matrix.component.html',
})
export class SotrRfpComplienceMatrixComponent implements OnInit {
  @Input() stepDetails: any;
  init: EditorComponent['init'] = init;
  @Input() visibleField: { sotr: boolean, rfp: boolean } = { sotr: true, rfp: true };
  @Input() url: string;
  @Input() proposalName: any;
  @Input() schemeType: any;

  @Output() routeConfig: EventEmitter<any> = new EventEmitter<any>();

  // venderList: any[] = [
  //   'Tata Consultancy Services',
  //   'Infosys Limited',
  //   'Wipro Limited',
  //   'HCL Technologies',
  //   'Tech Mahindra'
  // ];
  venderList: any[] = [];
  payload: any;
  complienceForm: FormGroup = new FormGroup({
    sotr_complience: new FormControl('', Validators.required),
    rfp_complience: new FormControl('', Validators.required),
  });
  complianceResponse: any;
  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {

    if (this.url)
      console.log('URL for compliance matrix:', this.url);
    this.getComplianceData();
  }

  getComplianceData(): void {
    this.api.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      // Extract vendor names from API response
      if (res?.vendor_data?.revenuevendor_step?.length) {
        this.venderList = res.vendor_data.revenuevendor_step.map((v: any) => v.company_name);
      }

      // Determine saved compliance data
      const savedData = Array.isArray(res?.data) ? res.data[0] : res?.data;
      this.complianceResponse = savedData;

      if (savedData && (savedData.sotr_complience || savedData.rfp_complience)) {
        // Load saved editor content from API
        this.complienceForm.patchValue({
          sotr_complience: savedData.sotr_complience || '',
          rfp_complience: savedData.rfp_complience || '',
        });
      } else {
        // Generate default templates using API vendor names
        this.complienceForm.patchValue({
          sotr_complience: getSotrRfpComplienceTemplate('SOTR COMPLIANCE MATRIX FOR ' + this.proposalName, this.venderList),
          rfp_complience: getSotrRfpComplienceTemplate('COMPLIANCE MATRIX FOR Encl I of RFP-SOTRs of ' + this.proposalName, this.venderList),
        });
      }
    });
  }


  onSubmit(): void {
    if (!this.url) return;
    const payload = {
      sotr_complience: this.complienceForm.get('sotr_complience')?.value,
      rfp_complience: this.complienceForm.get('rfp_complience')?.value,
      proposal_step: this.stepDetails?.id,
    };

    const handleResponse = (successMsg: string) => ({
      next: (_: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: successMsg });
        this.getComplianceData();
      }
    });

    const isUpdate = !!(this.complianceResponse && this.complianceResponse.id);
    if (isUpdate) {
      this.api.putAPI(`${this.url}${this.complianceResponse.id}/`, payload)
        .subscribe(handleResponse(this.stepDetails.name + ' updated successfully.'));
    } else {
      this.api.postAPI(this.url, payload)
        .subscribe(handleResponse(this.stepDetails.name + ' submitted successfully.'));
    }
  }


}
